export const isLastIndex = (arr: unknown[], idx: number): boolean => {
  return arr.length - 1 === idx
}
